import { BrowserRouter, Route, Routes } from "react-router-dom";

import ProtectedLayout from "../layouts/ProtectedLayout";
import PublicLayout from "../layouts/PublicLayout";
import DefaultLayout from "../layouts/DefaultLayout";
import BuilderLayout from "src/layouts/BuilderLayout";

//:- Pages to be rendered on specific endpoints
import AnalyticsLogin from "../pages/LoginPage";
import DashboardPage from "../pages/DashboardPage";
import ReportPage from "src/pages/ReportPage";
import DashboardBuilder from "src/pages/DashboardBuilder";
import UserManagement from "src/pages/UserManagement";



export default function AnalyticsRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* All Protected Routes will be placed in this group */}
        <Route element={<ProtectedLayout />}>
          <Route path="/reports/:report_name" element={<ReportPage />} />
          <Route path="/dashboards/:dashboard_name?" element={<DashboardPage />} />
          <Route path="/user-management" element={<UserManagement />} />
        </Route>

        {/* All Protected Buider Routes will be placed in this group */}
        <Route element={<BuilderLayout />}>
          <Route path="/builder/:dashboard_name?" element={<DashboardBuilder />} />
        </Route>

        <Route element={<PublicLayout />}>
          <Route path="/users/sign_in" element={<AnalyticsLogin />} />
        </Route>

        <Route path="/" element={<DefaultLayout />} />
        <Route path="*" element={<DefaultLayout />} />
      </Routes>
    </BrowserRouter>
  );
};
